import { render, staticRenderFns } from "./input-error.vue?vue&type=template&id=dcc36a3e&scoped=true&lang=pug"
import script from "./input-error.vue?vue&type=script&lang=js"
export * from "./input-error.vue?vue&type=script&lang=js"
import style0 from "./input-error.vue?vue&type=style&index=0&id=dcc36a3e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc36a3e",
  null
  
)

export default component.exports